export const PACKAGES = [
  {
    id: "single",
    testid: "pricing-card-single",
    tier: "Voucher Base",
    duration: "fino a 10 min",
    credits: 1,
    name: "Consulenza Base",
    priceNet: "€60",
    priceGross: "€73,20",
    badge: "Più Richiesta",
    desc: "1 consulenza con chiamata generica fino a 10 minuti per risolvere una piccola infestazione.",
    includes: [
      "Analisi foto/video del problema",
      "Identificazione esatta della specie",
      "Lista prodotti da acquistare (link diretti)",
      "Assistenza WhatsApp 1h post-chiamata",
      "Chiamata entro 24h dalla prima risposta su WhatsApp",
      "Servizio disponibile dal Lunedì al Venerdì, 9.00-18.00",
    ],
  },
  {
    id: "premium",
    testid: "pricing-card-premium",
    tier: "Voucher Premium",
    duration: "fino a 20 min",
    credits: 1,
    name: "Consulenza Premium",
    priceNet: "€120",
    priceGross: "€146,40",
    badge: "Consigliata dal Dottore",
    popular: true,
    desc: "1 consulenza con chiamata approfondita fino a 20 minuti per infestazioni più complesse.",
    includes: [
      "Analisi foto/video del problema",
      "Identificazione esatta della specie",
      "Lista prodotti da acquistare (link diretti)",
      "Assistenza WhatsApp 2h post-chiamata",
      "Chiamata entro 24h dalla prima risposta su WhatsApp",
      "Servizio disponibile dal Lunedì al Venerdì, 9.00-19.00",
    ],
  },
  {
    id: "business",
    testid: "pricing-card-business",
    tier: "Voucher VIP",
    duration: "fino a 40 min",
    credits: 1,
    name: "Consulenza VIP",
    priceNet: "€240",
    priceGross: "€292,80",
    badge: "Priorità Massima 7/7",
    vip: true,
    desc: "1 consulenza dedicata ai clienti più esigenti che hanno bisogno di risposte immediate, 7 giorni su 7.",
    includes: [
      "Analisi foto/video del problema",
      "Identificazione esatta della specie",
      "Lista prodotti da acquistare (link diretti)",
      "Chiamata/videochiamata immediata entro 2 ore dal contatto WhatsApp",
      "Fino a 40 minuti di chiamata",
      "Servizio disponibile 7 giorni su 7, dalle 7.00 alle 24.00",
    ],
  },
];
